import { INVITATION_STATUS } from 'constants/common';
import { USER_ROLE } from 'constants/common';

/** Who created the partner invite — matches API `invite_by`. */
export function normalizeInviteBy(row: any): 'student' | 'parent' | null {
  const raw = row?.invite_by ?? row?.inviteBy;
  if (raw == null || String(raw).trim() === '') return null;
  const v = String(raw).toLowerCase();
  if (v === USER_ROLE.student || v === 'student') return 'student';
  if (v === USER_ROLE.parent || v === 'parent') return 'parent';
  return null;
}

export function isInviteListRowConnected(row: any): boolean {
  return row?.requested_status === INVITATION_STATUS.approved;
}

/** Parent UI: parent must approve/decline (student sent the invite). */
export function isParentInviteActionPending(row: any): boolean {
  return (
    row?.requested_status === INVITATION_STATUS.pending && normalizeInviteBy(row) === 'student'
  );
}

/** Student UI: student must approve/decline (parent sent the invite). */
export function isStudentInviteActionPending(row: any): boolean {
  return (
    row?.requested_status === INVITATION_STATUS.pending && normalizeInviteBy(row) === 'parent'
  );
}
